'use strict';
 /**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectQuarterModalSelectController from "./controller/projectQuarterModalSelect.controller";

export default angular.module('investmentProject.project.quarter', [])
    .controller('ProjectQuarterModalSelectController', ProjectQuarterModalSelectController)
    .name;